import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "components/translations/useTranslation";
import {
    ExceptionForm,
    buildExceptionRow,
    isExceptionSaveEnabled,
} from "components/modals/ExceptionForm.component";
import { EditExceptionProps, ExceptionUserOption } from "types/modals";

const EditException = ({ more, closeModal, loopFocus }: EditExceptionProps): React.ReactElement => {
    const { translate } = useTranslation();

    const { noDuplicates, rows, hideClose, handleAction, requester, role } = more;

    // Requester and role are fixed for an existing exception - only the approvers can be edited.
    const [approvers, setApprovers] = useState<ExceptionUserOption[] | undefined>(more.approver);

    const filterValues = useMemo(
        () => (noDuplicates ? (rows || []).map((row) => row.value) : []),
        [noDuplicates, rows],
    );

    const handleApproversChange = useCallback((value: ExceptionUserOption[] | null) => {
        setApprovers(value ?? undefined);
    }, []);

    const handleOk = useCallback(() => {
        handleAction(buildExceptionRow(requester, role, approvers));
        closeModal();
    }, [requester, role, approvers, handleAction, closeModal]);

    return (
        <ExceptionForm
            translate={translate}
            requester={requester}
            role={role}
            approvers={approvers}
            filterValues={filterValues}
            onApproversChange={handleApproversChange}
            requesterRoleDisabled={true}
            maxMenuHeight={100}
            hideClose={hideClose}
            okText={translate("workflowDetails.exceptions.editException")}
            isSaveEnabled={isExceptionSaveEnabled(requester, role, approvers)}
            onOk={handleOk}
            onCancel={closeModal}
            loopFocus={loopFocus}
        />
    );
};

export default EditException;
